<template>
  <div class="container">
    <div class="wrapper">
      <!-- トータル件数表示 -->
      <div class="content_numDisp">
        <p
          v-if="total"
          class="mb-0"
          :style="{ fontSize: innerWidth <= 744 && totalFontSizeSP + 'px' }"
        >
          <span class="content_total">
            <span
              class="content_total_num"
              :style="{
                fontSize: innerWidth <= 744 && totalNumFontSizeSP + 'px'
              }"
            >
              {{ total }}</span
            >件中</span
          >{{ (currentPage - 1) * size_ + 1 }}～{{ total > currentPage * size_ ? currentPage * size_ : total }}件表示
        </p>
        <p
          v-else
          class="mb-0"
          :style="{ fontSize: innerWidth <= 744 && totalFontSizeSP + 'px' }"
        >
          <span>
            <span
              class="content_total_num"
              :style="{
                fontSize: innerWidth <= 744 && totalNumFontSizeSP + 'px'
              }"
            >
              0
            </span>
            件中
          </span>
          0件表示
        </p>
      </div>

      <!-- ページネーション本体 -->
      <div v-if="this.total > 10" class="content_paginator">
        <a
          class="content_paginator_icon content_paginator_first"
          :class="{ 'is-disable': currentPage == 1 }"
          @click="pageChange(1, currentPage == 1)"
          ><Icon name="arrow_first_page"
        /></a>
        <a
          class="content_paginator_icon content_paginator_prev"
          :class="{ 'is-disable': currentPage == 1 }"
          @click="pageChange(currentPage - 1, currentPage == 1)"
          ><Icon name="arrow_left"
        /></a>

        <!-- PCレイアウト時 -->
        <ul v-if="innerWidth > 744" class="content_paginator_pages">
          <li
            v-for="page in pageRange(false)"
            :key="page"
            :class="isCurrent(page) ? 'is-current' : ''"
            @click="pageChange(page)"
          >
            {{ page }}
          </li>
        </ul>
        <!-- SPレイアウト時 -->
        <ul v-else class="content_paginator_pages">
          <li
            v-for="page in pageRange(true)"
            :key="page"
            :class="isCurrent(page) ? 'is-current' : ''"
            @click="pageChange(page)"
          >
            {{ page }}
          </li>
        </ul>
        <a
          class="content_paginator_icon content_paginator_next"
          :class="{ 'is-disable': currentPage == lastPage }"
          @click="pageChange(currentPage + 1, currentPage == lastPage)"
          ><Icon name="arrow_right"
        /></a>
        <a
          class="content_paginator_icon content_paginator_last"
          :class="{ 'is-disable': currentPage == lastPage }"
          @click="pageChange(lastPage, currentPage == lastPage)"
          ><Icon name="arrow_last_page"
        /></a>
      </div>

      <!-- ソート選択欄 -->
      <div v-if="isSort" class="c-paginator__sort">
        <Icon
          class="c-paginator__sort__icon"
          name="action_sort"
          width="20px"
          height="20px"
        />
        <FormsSelect :value="selected" @change="$emit('changeSort')">
          <option v-for="(item, i) in sortList" :key="i" :value="item.value">
            {{ item.label }}</option
          >
        </FormsSelect>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      required: false
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: false
    },
    isSort: {
      type: Boolean,
      default: false
    },
    sortList: {
      type: Array,
      default: () => []
    },
    /**
     * フォントサイズ：「xx件中yy〜zz件表示」
     * 初期値：14
     */
    totalFontSizeSP: {
      type: Number,
      default: 14
    },
    /**
     * フォントサイズ：合計件数
     * 初期値：16
     */
    totalNumFontSizeSP: {
      type: Number,
      default: 16
    }
  },
  data: () => ({
    range: 2,
    selected: null,
    innerWidth: window.innerWidth
  }),
  computed: {
    size_() {
      return this.size || this.$config.pageSize
    },
    pagination() {
      return [...Array(Math.ceil(this.total / this.size_)).keys()].map(
        (n) => n + 1
      )
    },
    currentPage() {
      if (!this.$route.query || !this.$route.query.page) return 1
      return parseInt(this.$route.query.page)
    },
    lastPage() {
      return this.pagination[this.pagination.length - 1]
    },
    pageRange() {
      let self = this
      return function(isSmartPhone) {
        let start = ''
        let end = ''

        if (self.currentPage < self.range) {
          start = 1
          end = self.range + 1
        } else if (self.currentPage > self.lastPage - self.range + 1) {
          start = self.lastPage - self.range
          end = self.lastPage
        } else {
          start = self.currentPage - Math.floor(self.range / 2)
          end = self.currentPage + Math.floor(self.range / 2)
        }
        if (self.lastPage <= self.range + 1) {
          start = 1
          end = self.lastPage
        }
        return self.calRange(start, end)

        // TODO: 次回フェーズ以降でページ表示数を変更する可能性があるためコメントアウト
        // if (!isSmartPhone) return self.calRange(start, end)
        // return [self.currentPage]
      }
    },
    sortValue() {
      let query = Object.assign({}, this.$route.query)
      if (!query.sort) return this.sortList[0]
      return query.sort
    }
  },
  mounted() {
    if (this.sortValue) this.selected = this.sortValue
  },
  methods: {
    pageChange(page, disabled = false) {
      if (disabled) return false
      let query = Object.assign({}, this.$route.query)
      this.$router.push({ query: { ...query, page } })
      this.$emit('pageChange', page)
    },
    isCurrent(page) {
      return page === this.currentPage
    },
    calRange(start, end) {
      const range = []
      for (let i = start; i <= end; i++) {
        range.push(i)
      }
      return range
    }
  },
  watch: {
    $route() {
      this.selected = this.sortValue
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-0 {
  margin-bottom: 0;
}

.container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.wrapper {
  display: flex;
  flex-direction: column;
}
.content {
  &_total {
    margin-right: 0 !important;
    font-weight: bold;
  }
  &_numDisp {
    margin-bottom: 20px;
    text-align: center;
  }
  &_paginator {
    display: flex;
    align-items: center;
    justify-content: center;
    &_icon {
      &.is-disable {
        opacity: 0.5;
        user-select: none;
        pointer-events: none;
        cursor: alias;
      }
      svg {
        display: block;
        width: 20px;
        height: 20px;
      }
    }

    &_first {
      margin-right: 30.5px;
    }
    &_prev {
      margin-right: 30.5px;
    }
    &_pages {
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: middle;
      text-align: center;
      margin-bottom: 2px;
      li {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        color: #1f2021;
        opacity: 0.4;
        &.is-current {
          opacity: 1 !important;
        }
        &:last-child {
          margin-right: 26.5px;
        }
        &:not(:last-child) {
          margin-right: 24px;
        }
      }
      li.is-current {
        font-weight: bold;
      }
    }
    &_next {
      margin-right: 30.5px;
    }
  }
}

@media screen and (max-width: 744px) {
  .content {
    &_numDisp {
      margin-bottom: 16px;
    }
    &_paginator {
      &_icon {
        svg {
          width: 18px;
          height: 18px;
        }
      }
      &_pages {
        margin-bottom: 0px;
        li {
          font-size: 13px;
          &:last-child {
            margin-right: 30.5px;
          }
        }
      }
    }
  }
}
</style>
